"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPrintFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M9 8.73a33.93 33.93 0 0114 0L24 9l1 .27V3H7v6.23L8 9zM29.51 13.13A22.61 22.61 0 0025 11.3c-.32-.1-.65-.19-1-.28s-.66-.17-1-.24a31.8 31.8 0 00-14 0c-.35.07-.68.15-1 .24s-.68.18-1 .28a22.28 22.28 0 00-4.51 1.83l-.49.29V23h5v6h18v-6h5v-9.58zM23 23.5V27H9V17h14v6.5z" })));
}
exports.default = SvgPrintFilled;
//# sourceMappingURL=PrintFilled.js.map